import React from 'react';
import { applyTheme, getStoredTheme, useAuth } from '../../contexts/AuthContext';
import { useApi } from '../../hooks/useApi';
import { useTranslation } from '../../contexts/LanguageContext';

export default function ThemeToggle({ small = false }) {
  const { token } = useAuth();
  const { api } = useApi();
  const { t } = useTranslation();
  const [theme, setTheme] = React.useState(getStoredTheme());

  const toggle = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    applyTheme(next);
    // Async-Sync zum Server (best effort, nicht blockierend)
    if (token) {
      api('auth/profile', { method: 'PUT', body: { theme: next } }).catch(() => {});
    }
  };

  const iconSize = small ? 13 : 14;

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      title={t('common.theme.toggleTitle')}
    >
      {theme === 'dark' ? (
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      ) : (
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="5" />
          <line x1="12" y1="1" x2="12" y2="3" />
          <line x1="12" y1="21" x2="12" y2="23" />
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
          <line x1="1" y1="12" x2="3" y2="12" />
          <line x1="21" y1="12" x2="23" y2="12" />
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
        </svg>
      )}
    </button>
  );
}
